<template>
  <section class="main">
    <h1 class="intro">
        <span class="intro__inner">{{ $t('CHANGE_EMAIL') }}</span>
    </h1>
    <div class="row">
        <div class="col col_1">
          <html-with-links class="text g-text" :html="$t('CHANGE_EMAIL_PAGE_DESC')" />

          <html-with-links class="text g-text" :html="$t('DO_NOT_USE_HOSTILE_EMAILS')" />

          <div class="email-form">
            <input class="input" :placeholder="$t('NEW_EMAIL')" v-model="newEmail" />
            <btn :loading="loading" @click.native="beginToChange">{{ $t('BEGIN_TO_CHANGE') }}</btn>
          </div>
        </div>
      </div>
  </section>
</template>

<script>
import Btn from '@/components/Button';
import HtmlWithLinks from '@/components/HtmlWithLinks';

export default {
  components: {
    Btn,
    HtmlWithLinks,
  },
  data() {
    return {
      loading: false,
      newEmail: '',
      ticket: '',
      code: '',
    };
  },
  computed: {
    title() {
      return this.$t('CHANGE_EMAIL');
    },
  },
  methods: {
    beginToChange() {
      this.loading = true;
      this.$api.changeEmail({ newEmail: this.newEmail }).then((response) => {
        this.ticket = response.ticket;
        return this.checkCode();
      }).finally(() => {
        this.loading = false;
      });
    },
    async checkCode() {
      this.code = await this.$prompt(this.$t('ENTER_CODE_SENT_TO_NEW_EMAIL'), this.code, { okText: 'CONFIRM' });

      try {
        await this.$api.changeEmail({
          newEmail: this.newEmail, ticket: this.ticket, code: this.code,
        });
      } catch (e) {
        if (e.message === 'ERROR_INVALID_EMAIL_VALIDATION_CODE') {
          return this.checkCode();
        }

        throw e;
      }

      this.code = '';

      this.$store.dispatch('getDevices');
      this.$store.dispatch('getConfig');

      this.$router.push('/success?title=EMAIL_CHANGE_SUCCESS_TITLE&description=EMAIL_CHANGE_SUCCESS_BODY');

      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

b {
  font-weight: 600;
}

.main {
  display: block;
  flex-grow: 1;
}

.intro {
  &__inner {
    margin-right: 5px;
  }

  &__status {
    font-size: inherit;
    font-weight: 400;
  }

  &:not(:first-child) {
    margin-top: 30px;
    margin-bottom: 20px;
  }
}

.text {
  margin-bottom: 8px;

  &::v-deep {
    ul {
      list-style: inside disc;
    }

    li:not(:last-child) {
      margin-bottom: 3px;
    }

    strong {
      font-weight: 700;
    }
  }
}

.row {
  display: flex;
  align-items: flex-start;

  @include notebook {
    flex-wrap: wrap;
  }
}

.col {
  &_1 {
    flex-grow: 1;
  }
}

.button {
  font-size: 16px;
}

.input,
.textarea {
  background: var(--tertiary-bg);
  border: 1px solid var(--tertiary-accent);
  border-radius: 2px;
  padding: 4px 6px;
  width: 150px;
  font-size: 14px;
  font-family: "IBM Plex Sans", sans-serif;
  color: var(--text-primary);

  &::placeholder {
    font-family: "IBM Plex Sans", sans-serif;
    color: var(--text-primary);
  }
}

.email-form {
    margin-top: 15px;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
}
</style>
